import { render, staticRenderFns } from "./CalcVersiones.vue?vue&type=template&id=2f3eccd8"
import script from "./CalcVersiones.vue?vue&type=script&lang=js"
export * from "./CalcVersiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports